/** @format */

import AllTranslations from '../merged/en.json';

export const isValidTranslationString = (possibleKey: string) => Object.keys(AllTranslations).includes(possibleKey);
